// extracted by mini-css-extract-plugin
export var body = "_j4-0";
export var sectionHeader = "_j4-4";
export var shortcutColumns = "_j4-2";
export var shortcutList = "_j4-1";
export var shortcutSection = "_j4-3";